import { render, staticRenderFns } from "./vertical-editor.vue?vue&type=template&id=c607f0a2&scoped=true&"
import script from "./vertical-editor.vue?vue&type=script&lang=js&"
export * from "./vertical-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c607f0a2",
  null
  
)

export default component.exports